module.exports = __webpack_public_path__ + "img/conveni-all.56e47c0d.png";